import { Button, ListItem } from '@mui/material'
import {
  GridColumnsManagement,
  type GridColumnsManagementProps,
  useGridApiContext,
} from '@mui/x-data-grid'
import { defaultUserSearchPreferences } from '@/features/userSettings/defaults'
import { useUserPreferences } from '@/features/userSettings/useUserPreferences'
import { useColumns } from './columns'

export const CustomColumnsManagement = (_props: GridColumnsManagementProps) => {
  const grid = useGridApiContext()
  const { updateUserSearchPreferences } = useUserPreferences()
  const columns = useColumns()

  const getColumnOrder = () => {
    const { columnOrder: defaultOrder } = defaultUserSearchPreferences
    const nextOrder = [...defaultOrder]
    const columns = grid.current.getAllColumns()

    columns
      .filter((cDef) => !defaultOrder.includes(cDef.field))
      .forEach((cDef) => nextOrder.push(cDef.field))

    return nextOrder
  }

  const handleReset = () => {
    //reload default columns
    grid.current.updateColumns(columns)

    const columnOrder = getColumnOrder()
    const { columnsToDisplay } = defaultUserSearchPreferences

    updateUserSearchPreferences({
      columnOrder,
      columnsToDisplay,
    })
  }

  return (
    <>
      <GridColumnsManagement disableResetButton />
      <ListItem>
        <Button variant="outlined" color="info" onClick={handleReset}>
          Reset to defaults
        </Button>
      </ListItem>
    </>
  )
}
